import React from 'react';
import { makeStyles } from '@material-ui/core';
import { ArrowForwardIosRounded as ArrowForwardIosRoundedIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  optionsSelect: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '22px 25px',
    color: 'var(--colorDefault)',
    borderBottom: '1px solid var(--backgroundPaper)',
    '& > svg': {
      color: 'var(--colorDefault)'
    },
    '&.selected': {
      color: 'var(--colorSystemInfo)',
      background: 'var(--backgroundDefault)'
    }
  },
  labelWrap: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    width: 40,
    marginRight: 16,
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      verticalAlign: 'middle',
      fontSize: 24
    }
  },
  label: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 5
  },
  description: {
    margin: 0,
    fontSize: 12
  },
  hoverStyle: {
    transition: '0.3s',
    '&:hover': {
      color: 'var(--colorSystemInfo)',
      background: 'var(--backgroundDefault)'
    }
  }
}));

const OptionsSelect = ({ value, description, icon, onClick, isSelected }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.optionsSelect} ${classes.hoverStyle} ${isSelected ? 'selected' : ''}`} onClick={onClick}>
      <span className={classes.labelWrap}>
        <span className={classes.icon}>{icon}</span>
        <div>
          <span className={classes.label}>{value}</span>
          {description && <p className={classes.description}>{description}</p>}
        </div>
      </span>
      <ArrowForwardIosRoundedIcon style={{ fontSize: 20 }} />
    </div>
  );
};

export default React.memo(OptionsSelect);
